import React from 'react';

import { useElementFilter } from '@backstage/core-plugin-api';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  value: {
    fontWeight: 'bold',
    overflow: 'hidden',
    lineHeight: '24px',
    wordBreak: 'break-word',
  },
  label: {
    textTransform: 'uppercase',
    fontSize: '12px',
    fontWeight: 'bold',
    letterSpacing: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontFamily: 'Gilroy',
  },
});

/**
 * Props for {@link AboutField}.
 *
 * @public
 */
export interface AboutFieldProps {
  label: string;
  value?: string;
  gridSizes?: Record<string, number>;
  children?: React.ReactNode;
}

/** @public */
export function AboutField(props: AboutFieldProps) {
  const { label, value, gridSizes, children } = props;
  const classes = useStyles();

  const childElements = useElementFilter(children, c => c.getElements());

  // Content is either children or a string prop `value`
  const content =
    childElements.length > 0 ? (
      childElements
    ) : (
      <Typography variant="body2" className={classes.value}>
        {value || `unknown`}
      </Typography>
    );
  return (
    <Grid item {...gridSizes}>
      <Box flex={1}>
        <Typography variant="h2" className={classes.label}>
          {label}
        </Typography>
      </Box>
      {content}
    </Grid>
  );
}
